/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION - COMMENT VOLUME: STYLES --------------- ++++++++++ */
export default theme => ({
  addetails: {
  }
});
